import { render, staticRenderFns } from "./UserViewMobileDialog.vue?vue&type=template&id=397ffb17&scoped=true&"
import script from "./UserViewMobileDialog.vue?vue&type=script&lang=js&"
export * from "./UserViewMobileDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserViewMobileDialog.vue?vue&type=style&index=0&id=397ffb17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397ffb17",
  null
  
)

export default component.exports